<template>
  <el-dialog :title="$t('message.customColumns')" :visible="visible" width="680px"
    custom-class="column-settings-dialog" :close-on-click-modal="false"
    @update:visible="$emit('update:visible', $event)">
    <!-- 父页面只传入当前状态允许配置的字段。 -->
    <el-checkbox-group v-model="selectedColumns" class="column-settings-list">
      <el-checkbox v-for="item in columns" :key="item.key" :label="item.key">
        {{ $t(item.labelKey) }}
      </el-checkbox>
    </el-checkbox-group>
    <span slot="footer" class="dialog-footer">
      <el-button @click="selectAll">{{ $t('message.showAllColumns') }}</el-button>
      <el-button @click="close">{{ $t('message.cancel') }}</el-button>
      <el-button type="primary" @click="save">{{ $t('message.save') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
// 组件只负责编辑和返回所选字段，本地存储与状态规则由使用页面处理。
export default {
  props: {
    // 配合 visible.sync 控制弹框开关。
    visible: Boolean,
    // 当前页面、当前状态允许选择的列。
    columns: {
      type: Array,
      default: () => [],
    },
    // 页面当前正在展示的列 key。
    value: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      selectedColumns: [],
    }
  },
  watch: {
    // 每次打开都复制父页面配置，取消时不会改变列表。
    visible(value) {
      if (value) {
        const availableKeys = this.columns.map(item => item.key)
        this.selectedColumns = this.value.filter(key => availableKeys.includes(key))
      }
    },
  },
  methods: {
    selectAll() {
      this.selectedColumns = this.columns.map(item => item.key)
    },
    close() {
      this.$emit('update:visible', false)
    },
    // 只提交选择结果，具体保存方式由父页面决定。
    save() {
      this.$emit('save', [...this.selectedColumns])
      this.close()
    },
  },
}
</script>

<style lang="scss" scoped>
.column-settings-list {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 18px 12px;

  /deep/.el-checkbox {
    margin-right: 0;
  }
}

// 统一自定义表头弹框内容区的左右留白。
/deep/.column-settings-dialog .el-dialog__body {
  padding-left: 40px;
  padding-right: 40px;
}
</style>
